/**
 * Recently Viewed Products methods
 * -----------------------------------------------------------------------------
 *
 * @namespace recentlyViewed
 */

import Flickity from 'flickity';

var recentlyViewedMethods = {
  data: function data() {
    return {
      recentlyViewed: []
    };
  },


  methods: {
    _initRecentlyViewed: function _initRecentlyViewed() {
      var $container = $('[data-template="product"]');
      var productObj = app.selectors.productObj;
      var currentProductHandle = void 0;
      var currentVariantId = void 0;

      app._getRecentlyViewed();

      // product page
      if ($(productObj, $container).html()) {
        productObj = JSON.parse($(productObj, $container).html()).product;
        currentProductHandle = productObj.handle;
        currentVariantId = app.currentVariant.id;

        app._addVariantToRecentlyViewed(currentProductHandle, currentVariantId);

        // filter data
        // exclude the current visited product
        app.recentlyViewed = app.recentlyViewed.filter(function (item) {
          return item.id !== currentVariantId;
        });
      }
    },


    /**
     * Gets the recentlyViewed Array from localStorage
     */
    _getRecentlyViewed: function _getRecentlyViewed() {
      var recentlyViewed = localStorage.getItem('user_recently_viewed');
      if (!recentlyViewed) {
        return;
      }
      recentlyViewed = JSON.parse(recentlyViewed);

      // exclude products that have the app.productExcludeTag (theme settings)
      var index = recentlyViewed.findIndex(function (x) {
        return x.tags.indexOf(app.productExcludeTag) > -1;
      });
      if (index > -1) {
        recentlyViewed.splice(index, 1);
      }

      // reverse
      recentlyViewed.reverse();
      // set data
      app.recentlyViewed = recentlyViewed;

      // init recently viewed carousel
      setTimeout(function () {
        var $carousel = $('[data-flickity-recently-viewed]');

        if ($carousel.length > 0) {
          var options = $carousel.data('flickity-recently-viewed');
          var flkty = new Flickity($carousel[0], options);
          flkty.resize();
        }
      }, 100);
    },


    /**
     * Checks if a variant exists in the recentlyViewed Array
     * @param  {variant}
     * @return {boolean}
     */
    _checkRecentlyViewed: function _checkRecentlyViewed(variantId) {
      var index = this.recentlyViewed.findIndex(function (x) {
        return x.id === variantId;
      });

      if (index === -1) {
        return false;
      }
      return true;
    },


    /**
     * Adds the selected variant in recentlyViewed Array
     * @param  {productHandle variantId}
     *
     */
    _addVariantToRecentlyViewed: function _addVariantToRecentlyViewed(productHandle, variantId) {
      var index = app.recentlyViewed.findIndex(function (x) {
        return x.id === variantId;
      });

      // push object to recentlyViewed Array only if it doesn't exists
      if (index === -1) {
        var currentVariant = app.currentVariant;

        // add additional properties to the object
        currentVariant.product_id = app.product.id;
        currentVariant.product_handle = productHandle;
        currentVariant.tags = app.product.tags;
        currentVariant.options_with_values = app.product.options_with_values;

        // default image
        if (currentVariant.option1 === 'Default Title' || app.currentVariant.featured_image === null) {
          currentVariant.featured_image = app.product.featured_image;
        } else {
          currentVariant.featured_image = app.currentVariant.featured_image.src;
        }

        app.recentlyViewed.push(currentVariant);
        localStorage.setItem('user_recently_viewed', JSON.stringify(app.recentlyViewed));
      }
    },


    /**
     * Adds a variant from recentlyViewed Array
     * @param  {variantId}
     *
     */
    _removeFromToRecentlyViewed: function _removeFromToRecentlyViewed(variantId) {
      var index = app.recentlyViewed.findIndex(function (x) {
        return x.id === variantId;
      });

      if (index > -1) {
        app.recentlyViewed.splice(index, 1);
        localStorage.setItem('user_recently_viewed', JSON.stringify(app.recentlyViewed));
      }
    },


    /**
     * Returns the variant Url from a given variant Id
     * @param  {productHandle, variantId}
     * @return {string}
     *
     */
    _getvariantUrl: function _getvariantUrl(productHandle, variantId) {
      return '/products/' + productHandle + '?variant=' + variantId;
    }
  }
};

export default recentlyViewedMethods;